import { render } from "./DataSwitcher.vue?vue&type=template&id=6b4bdd02"
import script from "./DataSwitcher.vue?vue&type=script&lang=js"
export * from "./DataSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__